import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { useStyles } from '../NotifyIcons.styles';

const NotifyErrorIcon = () => {
  const { classes } = useStyles();
  return <ErrorIcon className={classes.icon} fontSize="small" />;
};

export default NotifyErrorIcon;
